import { M8PartnerIncomeHistoryRecord } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

type Params = {
  idPartner: number;
  page: number;
};

export async function getPartnerIncomeHistory(
  params: Params
): Promise<M8PartnerIncomeHistoryRecord[]> {
  const url = getM8AdminURL(
    `getPartnerIncomeHistory?${createQueryString(params)}`
  );

  const response = await fetch(url);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
}
